import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BreadcrumbsService } from "src/app/services/breadcrumbs.service";
import { BreadcrumbsModule } from "@storeblocks/breadcrumbs-ng";
import { FmsPipe } from "src/app/modules/shared/pipes/fms.pipe";

@Component({
  selector: "app-breadcrumbs-rebrand",
  standalone: true,
  imports: [BreadcrumbsModule, FmsPipe],
  templateUrl: "./breadcrumbs.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  private readonly breadcrumbsService = inject(BreadcrumbsService);

  public breadcrumbItems = this.breadcrumbsService.breadcrumbItems;

  public navigateBack(): void {
    history.back();
  }
}
